import Image from 'next/image';
import { StakingPool } from 'api/StakingAPI';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@dapp/multi-lib/sdaoui/Typography';
import { getStaticAssetUrl } from 'utils/url';

export const StakingPoolTVL = ({ pool }: { pool: StakingPool }) => {
  const { t } = useTranslation('common');

  const maximumFractionDigits = Number(pool.totalValueLockedUSD) > 1000 ? 0 : 2;

  return (
    <div className='flex flex-col items-end gap-1'>
      <div className='flex flex-row items-center gap-2'>
        <Image
          height={14}
          width={14}
          src={getStaticAssetUrl(
            `/sfi/static/image/token/${pool.rewardsTokenSymbol}.svg`
          )}
          alt={pool.rewardsTokenSymbol}
        />
        <Typography className='text-base font-semibold text-[#F7F8F8]'>
          {t('tokenAmount', {
            value: pool.tokensStaked,
            minimumFractionDigits: 0,
            maximumFractionDigits: maximumFractionDigits,
          })}
        </Typography>
      </div>
      <Typography className='text-xs text-[#B4BCD0]'>
        $
        {t('currency', {
          value: pool.totalValueLockedUSD,
          minimumFractionDigits: 0,
          maximumFractionDigits,
        })}
      </Typography>
    </div>
  );
};
